<template>
    <div class="p-4 lg:w-1/1 md:w-full">
        <div class="flex items-center gap-2 mt-5">
            <JetLabel class="w-1/4" for="metode_evaluasi" value="Metode Penyampaian Dokumen Penawaran" />
            <div class="flex items-center gap-4 w-3/4">
                <RadioButton v-model="form.metode_evaluasi
                    " @change="fetchBobotPenilaian
                        " inputId="1f" value="1f" />
                <label for="1f" class="ml-2">Satu File</label>
                <RadioButton v-model="form.metode_evaluasi
                    " @change="fetchBobotPenilaian
                        " inputId="2f" value="2f" />
                <label for="2f" class="ml-2">Dua File</label>
            </div>
        </div>
        <div class="flex items-center gap-2 mt-5">
            <JetLabel class="w-1/4" value="Bobot Penilaian (%)" />
            <div class="flex w-3/4 gap-2">
                <div v-if="loadingBobot" class="loader mr-5 mb-3">
                    Loading...
                </div>
                <div v-else class="flex items-center" style="gap: 0.5rem"
                    v-for="each_bobot in form.list_bobot_penilaian">
                    <label class="mr-1">{{
                        each_bobot.nama_jenis_bobot
                    }}</label>
                    <InputNumber v-model.number="each_bobot.percentage
                        " :min="calculateMin(
                            each_bobot
                        )
                            " :max="calculateMax(
                                each_bobot
                            )
                                " :mode="'decimal'" :suffix="'%'" :readonly="form.metode_evaluasi === '1f'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Inertia } from "@inertiajs/inertia";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";

export default defineComponent({
    components: {
        InputNumber,
        Dropdown,
        RadioButton,
    },
    props: {
        action: String,
        dataViewDokumenPengadaan: Object,
        files: [Object, Array],
        form: Object,
        id_paket_pengadaan: Number
    },
    mounted() {

    },
    data() {
        return {

        };
    },
    methods: {

        async fetchPaketPengadaan(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_paket_pengadaan",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    }
                );
                this.pengadaanOption = response.data;
            } catch (error) {
                this.loadingBobot = false;
                console.error("Error fetching penyedia:", error);
            }
        },
        async fetchBobotPenilaian() {
            this.loadingBobot = true;
            try {
                const response = await axios.post(
                    "/bobot_penilaian/list_bobot_by_jenis_pengadaan",
                    {
                        params: {
                            jenis_pengadaan: this.form.metode_evaluasi || "",
                        },
                    }
                );
                this.form.listBobotPenilaian = response.data.map((item) => ({
                    ...item,
                    percentage: item.default_percentage,
                }));
                this.loadingBobot = false;
            } catch (error) {
                console.error("Error fetching penyedia:", error);
            }
        },

        changeMetodeEvaluasi(event) {
            console.log("Event : ", event.value.id);

            if (event.value.penyedia_jenis_pekerjaan_id != 3) {
                this.form.metode_evaluasi = "1f";
            } else {
                this.form.metode_evaluasi = "2f";
            }
            this.fetchBobotPenilaian();
        }
    },
});
</script>